import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="py-10 md:py-16 px-4 bg-chem-navy text-white text-center" data-id="element-58" data-mp="3ucne9srvjhu1">
      <div className="max-w-3xl mx-auto flex flex-col items-center" data-id="element-59" data-mp="3ueqfza2e2zel">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 bg-chem-amber/15 border border-chem-amber/30 px-4 py-2 rounded-full mb-4" data-id="element-60" data-mp="c8c035kk8fdk">
          <span className="text-chem-amber text-xs md:text-sm font-bold uppercase tracking-wider" data-id="element-61" data-mp="h4u5m7npshqy">
            🔥 OFERTA ESPECIAL DE LANZAMIENTO
          </span>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-3xl md:text-6xl font-black mb-3 leading-tight" data-id="element-62" data-mp="qveyrfkmcu2h">
          MEGAPACK QUÍMICA VISUAL™ <br data-id="element-63" data-mp="2c56eid8eslnm" />
          <span className="text-chem-turquoise" data-id="element-64" data-mp="2c5g80asnxay2">EDICIÓN LATAM</span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.15
      }} className="text-white text-lg md:text-2xl font-bold mb-4" data-id="element-65" data-mp="2h37xky5u4kz3">
          Tu próxima clase de Química no tiene que empezar desde cero.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-white/65 text-sm md:text-lg font-medium mb-7 max-w-2xl leading-relaxed" data-id="element-66" data-mp="2v38zmgxu5yg5">
          Ten recursos listos para explicar, trabajar, evaluar y recuperar
          contenidos; y vuelve a reservar más tiempo para enseñar, descansar o
          compartir fuera de la escuela.
        </motion.p>

        <motion.button animate={{
        boxShadow: ['0 0 15px rgba(22,163,74,0.2)', '0 0 30px rgba(22,163,74,0.5)', '0 0 15px rgba(22,163,74,0.2)'],
        scale: [1, 1.03, 1]
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} transition={{
        boxShadow: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        },
        scale: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }} onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full max-w-md bg-chem-green hover:bg-green-700 text-white font-black text-base md:text-2xl py-6 rounded-2xl shadow-[0_20px_50px_rgba(22,163,74,0.3)] mb-8 uppercase tracking-tight transition-colors" data-id="element-67" data-mp="3itd40qium287">
          Acceder a los recursos ahora
        </motion.button>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="flex flex-col items-center gap-4" data-id="element-68" data-mp="d17xl91766co">
          <div className="flex items-center gap-2 bg-chem-green/15 px-4 py-1.5 rounded-full border border-chem-green/30" data-id="element-69" data-mp="6ze6g7p3du1u">
            <div className="w-2 h-2 bg-chem-green rounded-full animate-pulse" data-id="element-70" data-mp="3uadujdy63cec" />
            <span className="text-chem-green text-xs md:text-sm font-black uppercase tracking-widest" data-id="element-71" data-mp="3u8aus277q4wf">
              +500 docentes ya lo tienen
            </span>
          </div>
          <p className="text-white/50 text-[10px] md:text-xs font-bold uppercase tracking-widest" data-id="element-72" data-mp="3kdraushkurdw">
            Material imprimible · Pago único · Acceso digital inmediato ·
            Garantía de 7 días
          </p>
        </motion.div>
      </div>
    </section>;
}